export default __webpack_public_path__ + "static/media/app.e3d799eb.jpg";